export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.205045be.ttf";